import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import App from './App';

// Sentry 错误监控初始化（填 REACT_APP_SENTRY_DSN 后启用官方云上报）
const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN || '';
if (SENTRY_DSN) {
  Sentry.init({
    dsn: SENTRY_DSN,
    environment: process.env.NODE_ENV || 'development',
    tracesSampleRate: 0.2,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
}

// 自建错误上报（Sentry 未配置时的兜底）：JS 崩溃/未捕获 Promise 拒绝 → 服务器
// error 日志。与 Sentry 并行：配置 DSN 后两边都收，不冲突。
function reportClientError(payload) {
  try {
    fetch('/api/client-errors', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        message: payload.message,
        stack: payload.stack,
        page: window.location.pathname,
        userAgent: navigator.userAgent,
        extra: payload.extra,
      }),
      keepalive: true,
    }).catch(() => {});
  } catch (_) { /* 上报自身绝不能引发二次错误 */ }
}

window.addEventListener('error', (event) => {
  reportClientError({
    message: event.message,
    stack: event.error && event.error.stack,
    extra: { source: event.filename, line: event.lineno },
  });
});

window.addEventListener('unhandledrejection', (event) => {
  reportClientError({
    message: `未捕获Promise拒绝: ${event.reason && (event.reason.message || event.reason)}`,
    stack: event.reason && event.reason.stack,
    extra: { type: 'unhandledrejection' },
  });
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
